import { Injectable } from "@angular/core";
import { HttpDataSource } from "@jeanologia/ng-interfaces";

@Injectable()
export class LicensesDataSource extends HttpDataSource {
	public getData(): void {
		this.loading.next(true);
		let query = this.getQuery();
		if (query.length > 0) {
			query += "&populate=true&active=true&isAssigned=true&type=basic";
		} else {
			query = "?populate=true&active=true&isAssigned=true&type=basic";
		}
		this.setQuery(query);
		this.getDataAsObservable().subscribe(this.emitData.bind(this), this.emitError.bind(this));
	}
}
